import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ExitProcessService } from 'src/app/_services/exit-process/exit-prosess.service';
import { error } from 'console';

@Component({
  selector: 'app-exit-finance',
  templateUrl: './exit-finance.component.html',
  styleUrls: ['./exit-finance.component.scss']
})
export class ExitFinanceComponent implements OnInit {
  @Output() clearanceEvent = new EventEmitter<any>();
  tenantId: string;
  currentUser: any;
  userClearanceForm;
  form: FormGroup;
  userDropdownList = [];
  resignationId: any;
  isHRAdmin: boolean;
  isFinanceAdmin: boolean;
  isITAdmin: boolean;
  isClearanceForm: boolean = false;
  modeAction: number = 1; //1 - create // 2 - update
  formMode: number = 0; // 0 - none // 1 - new form // 2 - edit form
  defaultColDef:any;
  rowSelection:any
  dataSource: any;
  public columnDefs: ColDef[];
  sampleGridFrameworkComponents: any;
  private api: GridApi;
  private columnApi: ColumnApi;
  selectedRow: any;
  rowData: any;
  clearanceUserId: any;
  editUserClearanceId: any;
  userClearanceData: any[] = [];
  isAckVisible: boolean;
  isFinanceAdminCleared: boolean = false;
  clearanceFromFinanceAdminItem: any;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private exitProcessService: ExitProcessService,
  ) {
    this.route.queryParams.subscribe(params => {
      this.resignationId = params['resignationId'];
    });

    {
      this.defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true,
      };
    }

    this.userClearanceForm = this.formBuilder.group({
      itemName: new FormControl(''),
      status: new FormControl(''),
      clearanceType: new FormControl(''),
      extraColumn1: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isFinanceAdmin = this.currentUser.roles.includes('RoleFinanceAdministrator');
    this.isHRAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
    this.getUserSeparation(this.resignationId);
  }

  getUserSeparation(resignationId){
    this.exitProcessService.getUserSeparationsById(resignationId).subscribe({
      next : (value) => {
        this.clearanceUserId = value['userId'];
        this.getClearanceInterviewForm();

        const clearanceData1 = this.userClearanceData.find(data => data.itemName === 'Clearance from Reporting Manager');
        const isDeptCleared = clearanceData1 ? clearanceData1.status === "Done" : null;

        const clearanceData2 = this.userClearanceData.find(data => data.itemName === 'Clearance From IT');
        const isITCleared = clearanceData2 ? clearanceData2.status === "Yes" : null;

        const clearanceData3 = this.userClearanceData.find(data => data.itemName === 'Clearance From Finance');
        const isFinanceCleared = clearanceData3 ? clearanceData3.status === "Yes" : null;

        const clearanceData4 = this.userClearanceData.find(data => data.itemName === 'Clearance From HR & Admin');
        const isHRCleared = clearanceData4 ? clearanceData4.status === "Yes" : null;
        
        if(isDeptCleared && isITCleared && isFinanceCleared && isHRCleared){
          this.isAckVisible === true
        }
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Resignation Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  getClearanceInterviewForm(){
    this.exitProcessService.getUserClearanceForm('AccountsAndFinance', this.resignationId).subscribe({
      next : (value: any) => {
        this.userClearanceData = [];
        // this.userClearanceData = value;

        this.userClearanceData = value.filter(
          item => item.clearanceType === 'AccountsAndFinance' &&
          item.itemName !== 'Clearance From Finance' // exclude this from table
        );

        this.clearanceFromFinanceAdminItem = value.find(
          item => item.clearanceType === 'AccountsAndFinance' &&
                  item.itemName === 'Clearance From Finance'
        );

        this.isFinanceAdminCleared = value.find(
          item =>
            item.clearanceType === 'AccountsAndFinance' &&
            item.itemName === 'Clearance From Finance'
        )?.status;

        this.clearanceEvent.emit(value);
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Clearance Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  onFinanceAdminClearanceChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const newStatus = checked ? 'Yes' : 'No';
  
    let updatePayload = {
      userId: this.clearanceUserId,
      itemName: this.clearanceFromFinanceAdminItem.itemName,
      status: newStatus,
      clearanceType: 'IT',
    }

    this.exitProcessService.editClearanceInterviewForm(updatePayload, this.clearanceFromFinanceAdminItem.id).subscribe({
      next: () => {
        this.clearanceFromFinanceAdminItem.status = newStatus;
        this.openSnackBar('Clearance status updated!!!');
      },
      error: (err) => {
        this.openSnackBar('Error updating clearance: ' + err);
      }
    });
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  cancelSave(){
    this.formMode = 0;
    this.isClearanceForm = false;
  }

  visibleUserClearanceForm() {
    if (this.formMode === 0) {
      this.isClearanceForm = true;
      this.formMode = 1;
      this.userClearanceForm.patchValue({
          itemName: '',
          status: '',
          extraColumn1: '',
          clearanceType: ''
      })
    } else if (this.formMode === 1) {
      this.userClearanceForm = false;
      this.formMode = 0;
    }
  }
  
  requiredSaveUserClearance() {
    if (this.userClearanceForm.status === 'INVALID') return true;
    else return false;
  }

  saveFinanceUserClearance(){
    let data = {
      userId: this.clearanceUserId,
      itemName: this.userClearanceForm.get('itemName').value,
      status: this.userClearanceForm.get('status').value,
      extraColumn1: this.userClearanceForm.get('extraColumn1').value,
      clearanceType: 'AccountsAndFinance',
    }
    if (!this.requiredSaveUserClearance()) {
      this.exitProcessService.createClearanceInterviewForm(data).subscribe({
        next: (value) =>{
          this.getClearanceInterviewForm();
          this.cancelSave();
          // this.formMode = 0;
          // this.userClearanceForm = false;
        },
        error(error){
          this.openSnackBar('ERROR: ' + error);
        },
        complete(){
          this.openSnackBar('Create Successfull!!!');
        }
      });
    }
  }

  updateFinanceUserClearance(){
    let data = {
      userId: this.clearanceUserId,
      itemName: this.userClearanceForm.get('itemName').value,
      status: this.userClearanceForm.get('status').value,
      extraColumn1: this.userClearanceForm.get('extraColumn1').value,
      clearanceType: 'AccountsAndFinance',
    }
    if (!this.requiredSaveUserClearance()) {
      this.exitProcessService.editClearanceInterviewForm(data, this.editUserClearanceId).subscribe({
        next: (value) =>{
          this.getClearanceInterviewForm();
          this.cancelSave();
          // this.formMode = 0;
          // this.userClearanceForm = false;
        },
        error(error){
          this.openSnackBar('ERROR: ' + error);
        },
        complete(){
          this.openSnackBar('Update Successfull!!!');
        }
      });
    }
  }

  editUserClearanceById(id) {
    this.formMode = 2;
    this.isClearanceForm = true;
    const idx = this.userClearanceData.findIndex(i => i.id === id);
    this.editUserClearanceId = id;
    this.userClearanceForm.patchValue({
      itemName: this.userClearanceData[idx].itemName,
      status: this.userClearanceData[idx].status,
      extraColumn1: this.userClearanceData[idx].extraColumn1
    });
  }

  deleteUserClearanceById(id) {
    this.exitProcessService.deleteClearanceInterviewForm(id).subscribe({
      next : (value) => {
        this.getClearanceInterviewForm();
      },
      error(err) {
        this.openSnackBar('ERROR: ' + err);
      },
      complete() {
        // this.openSnackBar('Delete Successfull!!!');
      }
    });
  }

  backToExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-process' ]);
  }

  openExitForm(){
    this.router.navigate([this.tenantId + '/dashboard/hr/exit-formalities/exit-form'], { queryParams: { resignationId: this.resignationId } });
  }

  openItHrmExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hrit' ], { queryParams: { resignationId: this.resignationId } });
  }

  openFinanceExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-finance' ], { queryParams: { resignationId: this.resignationId } });
  }

  openDepartmentExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-department'], {queryParams: {resignationId: this.resignationId}});
  }

  openHrExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hr-admin'], {queryParams: {resignationId: this.resignationId}});
  }

  employeeAnknow(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/emply-anknowledge'], {queryParams: {resignationId: this.resignationId}});
  }

}
